import { UnknownSchema } from '../../constants'
import { SchemaDefinition } from '../../models/SchemaDefinition'

import type { SchemaIdentifierSpecific, TypedSchema } from '../../types'

export class SchemaIdentifierDefinition extends SchemaDefinition {
  override defaultsMerge(value: any) {
    return value
  }

  override getIn(schema: SchemaIdentifierSpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(target: any, schema: SchemaIdentifierSpecific): TypedSchema {
    return { ...schema, ...super.inferShapeSchema(target) } as TypedSchema
  }

  override inferOnlySchema(schema: SchemaIdentifierSpecific) {
    return schema
  }

  override inferTypeScript(schema: SchemaIdentifierSpecific): string {
    return schema.value ?? ''
  }

  override prune(target: any): any {
    return target
  }

  override transform(target: any, schema: SchemaIdentifierSpecific) {
    if (target === null && schema.nullable) return target
    if (target === undefined) return schema.fallback
    return target
  }

  override validate(target: any, schema: SchemaIdentifierSpecific): void {
    this.validateMetadata(target, schema)
  }
}
